<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <sidebar-item v-if="$store.state.auth.params.User && $store.state.auth.params.User != undefined && Object.keys(sideBarItens).length > 1"
         :link="{
          name: homeMenu.name,
          icon: `no no-home-3 ${$route.path == '/' + $store.state.auth.params.User.indexpage ? '  text-blue bg-white circle' : ''}`,
          path: `/${$store.state.auth.params.User.indexpage}`,
        }" />

<!-- TODO: não repetir o menu qnd é igual ao link  da home -->
        <div v-for="(role, index) in sideBarItens" :key="index">
          <sidebar-item v-if="$store.state.auth.params.User && $store.state.auth.params.User.indexpage != `${role.controller}/${role.action}` || Object.keys(sideBarItens).length == 1" :key="index" :link="{
            name: role.name,
            path: `/${role.controller}/${role.action}`,
            icon: `${role.icon || getRoleIcon(role)} ${$route.path == '/' + role.controller + '/' + role.action ? 'text-blue bg-white circle' : ''}`,
          }" />
        </div>
        <!-- <sidebar-item :link="{
          name: 'Configurações',
          icon: 'no no-cogwheel-3',
          path: '/configurations',
        }" /> -->


        <a href="#" class="nav-link" @click.prevent>
          <i class="no no-c-question-3 text-white bg-indigo circle" @click="showHelpChoknowledgebase()"></i>
          <span class="nav-link-text" @click="showHelpChoknowledgebase()">Ajuda</span>

        </a>

        <!-- Templete sidebar Itens. Must to be hide in production mode.. -->
        <div v-show="!hideTemplateSidebarItens">
          <hr class="my-3" />
          <b-nav-item class="nav-item">
            <h6 class="navbar-heading text-white p-0">EXEMPLOS DE MENU</h6>
          </b-nav-item>
          <sidebar-item :link="{
            name: 'DEV: Calendário',
            icon: 'ni ni-calendar-grid-58 text-white',
            path: '/operation/index',
          }" />
          <sidebar-item :link="{
            name: 'DEV: Dashboard Operador',
            icon: 'ni ni-calendar-grid-58 text-white',
            path: '/operation/booking-list',
          }" />
          <sidebar-item :link="{
            name: 'DEV: Condutores',
            icon: 'ni ni-circle-08 text-white',
            path: '/agents/index',
          }" />
          <sidebar-item :link="{
            name: 'Atrativos',
            icon: 'no no-image-mountain',
            path: '/products/index',
          }" />
          <sidebar-item :link="{
            name: 'DEV: Relatórios',
            icon: 'ni ni-collection text-white',
          }">
            <sidebar-item :link="{
              name: 'DEV: Relatório de vendas',
              path: '/reports/sales',
            }" />
            <sidebar-item :link="{
              name: 'DEV: Relatório de visitação',
              path: '/reports/visits',
            }" />
            <sidebar-item :link="{
              name: 'DEV: Relatório de seguros',
              path: '/reports/booking',
            }" />
          </sidebar-item>
          <sidebar-item :link="{
            name: 'DEV: Financeiro',
            icon: 'ni ni-money-coins text-white',
            path: '/financial/index',
          }" />
          <sidebar-item :link="{
            name: 'DEV: Configurações',
            icon: 'ni ni-settings-gear-65 text-white',
            path: '/configurations',
          }" />
          <sidebar-item :link="{
            name: 'Dev: Trafx',
            path: '/trafx',
            icon: 'ni ni-sound-wave text-white',
          }" />

          <sidebar-item :link="{
            name: 'DEV: Reserva expressa',
            icon: 'ni ni-collection text-white',
          }">
            <sidebar-item :link="{
              name: 'DEV: Lençóis',
              path: '/booking/?eyJwbGFjZV91dWlkIjoiNTY2MkM4OTQtQUJBRS0xMUVDLThCRjYtRjIzQzkyMjdFQzhEIiwiJnVzZXJfdXVpZCI6IjM5NUVFQ0M3LTM4NDctMTFFRC04QUI1LUYyM0M5MjI3RUM4RCJ9',
            }" />
            <sidebar-item :link="{
              name: 'DEV: Buracão',
              path: '/booking/?eyJwbGFjZV91dWlkIjoiMkYyNDkwNTYtQTc3OC0xMUVCLTk3MDItNTI1NDAwNkNDMzA5IiwiJnVzZXJfdXVpZCI6IkVEMTUwRTc2LTRCMzEtMTFFRC04NTM0LUYyM0M5MjI3RUM4RCJ9',
            }" />
          </sidebar-item>
          <sidebar-item :link="{
            name: 'DEV: Clientes',
            path: '/clients',
            icon: 'ni ni-circle-08 text-white',
          }" />
          <sidebar-item :link="{
            name: 'DEV: Monitor de Serviços',
            path: '/clients/services',
            icon: 'ni ni-glasses-2 text-white',
          }" />
          <sidebar-item :link="{
            name: 'DEV: Nota Fiscal',
            path: '/nf',
            icon: 'ni ni-paper-diploma text-white',
          }" />
        </div>
      </template>

      <template slot="links-after">
        <div v-show="!hideTemplateSidebarItens">
          <hr class="my-3" />
          <h6 class="navbar-heading p-0 text-white">Documentation</h6>

          <b-nav class="navbar-nav mb-md-3" style="padding-bottom: 60px">
            <b-nav-item href="https://www.creative-tim.com/learning-lab/bootstrap-vue/quick-start/argon-dashboard">
              <i class="ni ni-spaceship"></i>
              <b-nav-text class="p-0">Getting started</b-nav-text>
            </b-nav-item>
            <b-nav-item href="https://www.creative-tim.com/learning-lab/bootstrap-vue/colors/argon-dashboard">
              <i class="ni ni-palette"></i>
              <b-nav-text class="p-0">Foundation</b-nav-text>
            </b-nav-item>
            <b-nav-item href="https://www.creative-tim.com/learning-lab/bootstrap-vue/avatar/argon-dashboard">
              <i class="ni ni-ui-04"></i>
              <b-nav-text class="p-0">Components</b-nav-text>
            </b-nav-item>
            <b-nav-item href="https://www.creative-tim.com/learning-lab/bootstrap-vue/charts/argon-dashboard">
              <i class="ni ni-chart-pie-35"></i>
              <b-nav-text class="p-0">Plugins</b-nav-text>
            </b-nav-item>
          </b-nav>

        </div>
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>
      <div>
      </div>
      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>

    <help-side-bar :loadingInfos="loadinfHelpInfo" @help-info-dismiss="showHelpSideBar = false" :info="sideBarInfos"
      :showHelpSideBar="showHelpSideBar" />
  </div>
</template>
<script src="/unicodesMap.json"></script>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar'
import 'perfect-scrollbar/css/perfect-scrollbar.css'
import { mapGetters } from 'vuex'
import HelpSideBar from '@/components/HelpSideBar/HelpSideBar'
// import HelpDrawer from "@/components/HelpDrawer/HelpDrawer";
import DashboardNavbar from './DashboardNavbar.vue'
import ContentFooter from './ContentFooter.vue'
// import DashboardContent from "./Content.vue";
import { FadeTransition } from 'vue2-transitions'
import store from '@/store'

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`)
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className)
    }, 100)
  }
}
export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    HelpSideBar,
    // DashboardContent,
    FadeTransition,
    // HelpDrawer
  },
  data() {
    return {
      bcClasses: '',
      hideNavbar: false,
      hideTemplateSidebarItens: true,
      sideBarItens: [],
      showHelpSideBar: false,
      sideBarInfos: '',
      loadinfHelpInfo: false,
    }
  },
  computed: {
    ...mapGetters('auth', {
      roles: 'roles',
    }),

    homeMenu(){
      let homeMenu = this.sideBarItens.find(item => item.controller+'/'+item.action == store.state.auth.params.User.indexpage)
      if(homeMenu == undefined){
        homeMenu = {name:'Início'}
      }
      return homeMenu
    }
  },
  methods: {
    getRoleIcon(role) {
      let icon = 'no no-file-text-3'
      let path = `/${role.controller}/${role.action}`
      switch (path) {
        case '/agents/index':
          icon = 'no no-users'
          break

        case '/reports/sales':
          icon = 'ni ni-money-coins'
          break

        case '/financial/index':
          icon = 'ni ni-money-coins'
          break

        case '/agents/index':
          icon = 'ni ni-single-02'
          break

        case '/products/index':
          icon = 'no no-image-mountain'
          break
        default:
          break
      }
      return icon
    },
    handleSideBarRoles() {
      for (var l in this.roles) {
        let sideBarElements = this.roles[l].filter((element) => {
          let visible = element.visible === 'main-menu'
          if (visible) {
            element.icon = this.getRoleIcon(element)
          }
          return visible
        })
        sideBarElements ? this.sideBarItens.push(...sideBarElements) : ''
      }
    },
    showHelpChoknowledgebase() {
      this.showHelpSideBar = true
      this.$sidebar.displaySidebar(false)
      var aparentPath = this.$route.path.split('/')[1]
      this.getArticleseChoknowledgebase(aparentPath)
    },
    getArticleseChoknowledgebase(path) {
      this.loadinfHelpInfo = true
      setTimeout(() => {
        this.loadinfHelpInfo = false
      }, 2000)
    },
    initScrollbar() {
      let isWindows = navigator.platform.startsWith('Win')
      if (isWindows) {
      }
      initScrollbar('sidenav')
    },
  },
  mounted() {
    this.hideTemplateSidebarItens = process.env.NODE_ENV === 'production'
    this.initScrollbar()
    this.handleSideBarRoles()
  },
  created() {
    if(window.location.origin.indexOf('//localhost') >= 0 ){
      window.location.href = window.location.href.replace('//localhost','//127.0.0.1')
      return false
    }
    if (
      window.location.href.indexOf('janoo.com.br') > 0 ||
      this.$route.query.hosted == 'janoo'
    ) {
      this.bcClasses += 'janoo_hosteded '
    }
  },
}
</script>

